// frontend/modules/coa/routes.tsx
import { RouteObject } from 'react-router-dom';
import { CoaManagement } from './views/CoaManagement';
import {ErrorBoundary} from "@/shared/components/ErrorBoundary";

export const coaRoutes: RouteObject[] = [
    {
        path: '/admin/account-settings/chart-of-accounts',  // Note: removed leading slash since these are child routes
        element: <CoaManagement />,
        errorElement: <ErrorBoundary />,

    }
];